<template>
  <div id="salesClientDetail">
    <div style="background-color: #fff; padding: 0 10px">
      <el-button
        @click="$router.go(-1)"
        style="color: #ff9901"
        icon="el-icon-arrow-left"
        type="text"
        >返回</el-button
      >
    </div>
    <div class="skuDe">
      <p style="color: #4d586d">{{ storeDetail.store_name || "暂无" }}</p>
      <p style="color: #b0b5b9; font-size: 12px; margin-top: 6px">
        {{ storeDetail.address || "暂无" }}
      </p>
      <p
        style="
          color: #7ed321;
          font-size: 14px;
          margin-top: 10px;
          display: inline-flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
        "
      >
        <!-- <span>三级甲等</span> -->
        <!-- <span
          ><i style="color: #ed3b3f">暂无目标客户&nbsp;</i
          ><i style="color: #4a90e2">|&nbsp;本月覆盖3人</i></span
        > -->
      </p>
    </div>
    <m-ym
      :value="month"
      @change="changeYM"
      format="YYYY-MM"
      style="padding: 10px 10px"
    ></m-ym>
    <div
      class="summary"
      style="height: 120px; background: #fff; padding: 0 20px"
    >
      <div class="summaryItem">
        <span
          style="
            color: #fff;
            padding: 4px 5px;
            background: #ff9901;
            font-size: 12px;
            border-radius: 4px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          "
          >{{ storeDetail.store_name || "暂无" }}</span
        >
        <span
          style="
            color: #4a90e2;
            font-size: 14px;
            padding-left: 5px;
            flex-shrink: 0;
          "
          >含税折后(万)&nbsp;<em>{{
            // (info.amount / 10000).toFixed(2)
            (info.discount_amount / 10000).toFixed(2)
          }}</em></span
        >
      </div>
      <div class="summaryItem summaryItem2">
        <span
          >指标:<em
            >{{ info.target_quantity }}&nbsp;<i
              class="rate"
              style="visibility: hidden"
              >%</i
            ></em
          ></span
        >
        <span
          >销售盒数:
          <!--          <em>{{ info.quantity }}</em>-->
          <em>{{ amount_quantity }}</em>
        </span>
        <span
          >达成率:<em style="color: #ed3b3f"
            >{{ info.rate.toFixed(1) }}&nbsp; <i class="rate">%</i></em
          >
        </span>
      </div>
      <div class="summaryItem summaryItem2">
        <span
          >考核毛利率:<em style="color: #4a90e2"
            >{{ info.gross_rate.toFixed(1) }}&nbsp;<i class="rate">%</i></em
          ></span
        >
        <span
          >上月销售(盒):<em style="color: #4a90e2">{{
            info.last_quantity
          }}</em></span
        >
        <span
          >增长率:<em style="color: #4a90e2"
            >{{ info.increase_rate.toFixed(1) }}&nbsp;<i class="rate">%</i></em
          ></span
        >
      </div>
    </div>
    <div ref="tableBox" style="overflow: hidden">
      <el-table
        v-loading="loading"
        :data="tableData"
        @row-click="salesClientYearDetail"
        style="width: 100%; background: #f5f7fa"
        :header-cell-style="headerCellStyle"
        @sort-change="sortChange"
        :cell-style="CellStyle"
      >
        <el-table-column prop="sku_name" label="产品"> </el-table-column>
        <el-table-column
          prop="target_amount"
          label="指标"
          sortable="custom"
          width="80"
        >
          <template slot-scope="scope">
            <div>
              <span>{{ scope.row.target_amount || "-" }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="discount_amount"
          label="实际"
          sortable="custom"
          width="80"
        >
          <template slot-scope="scope">
            <div>
              <span>{{ scope.row.discount_amount || "-" }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="rate"
          label="达成率"
          sortable="custom"
          width="90"
        >
          <template slot-scope="scope">
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
              "
            >
              <span>{{ scope.row.rate || "-" }}</span>
              <img
                src="../../assets/images/next.png"
                style="float: right"
                height="11"
                alt="产品详情"
              />
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div
      style="
        color: #4a90e2;
        font-size: 14px;
        font-weight: bold;
        background: #e0e0e0;
        padding: 10px;
      "
    >
      合计:<em>&nbsp;&nbsp;{{ amount_quantity }}</em>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
import http from "../../APIService/http";
import moment from "moment";
import mYm from "./components/YMselect";
import { mapState, mapMutations } from "vuex";
export default {
  name: "salesClientDetail",
  data() {
    return {
      amount_quantity: 0,
      info: {
        amount: 0,
        last_quantity: 0,
        quantity: 0,
        target_quantity: 0,
        rate: 0,
        gross_rate: 0,
        increase_rate: 0,
      },
      storeDetail: {
        store_name: "",
        address: "",
      },
      tableData: [],
      loading: false,
      month: this.$store.state.salesData.month,
    };
  },
  components: {
    mYm,
  },
  computed: {
     query() {
      return this.$store.getters.getDataQuery;
    },
    store_id() {
      return this.$store.getters.getSalesStoreId;
    },
    territoryArr() {
      return this.$store.getters.getTerritoryArr;
    }
  },
  created() {
    this.getStoreDetail();
    this.SalesClientDetail();
    this.SalesClientStatistics();
  },
  mounted() {},
  methods: {
    ...mapMutations(["setDataKey"]),
    setTableHeight() {
      this.$nextTick(() => {
        this.tableheight = parseFloat(
          window.getComputedStyle(this.$refs.tableBox).height
        );
      });
    },
    changeYM(val) {
      this.month = val;
      // this.setDataKey({ month: val });
      this.SalesClientDetail();
      this.SalesClientStatistics();
    },
    SalesClientStatistics() {
      let forms = {
        tenant_id: this.query.tenant_id,
        store_id: this.store_id,
        user_id: this.query.user_id,
        territoryIds: [...this.territoryArr],
        month: this.month || moment().format("YYYY-MM"),
      };

      http
        .post("b2b_sever/gkGetFeedback/SalesClientStatistics", forms)
        .then((res) => {
          this.info = res.data;
        });
    },
    getStoreDetail() {
      let forms = {
        tenant_id: this.query.tenant_id,
        store_id: this.store_id,
      };
      http.post("b2b_sever/gkGetFeedback/getStoreDetail", forms).then((res) => {
        this.storeDetail = res.data;
        this.$nextTick(() => {
          this.setTableHeight();
        });
      });
    },
    SalesClientDetail() {
      let forms = {
        tenant_id: this.query.tenant_id,
        user_id: this.query.user_id,
        territoryIds: [...this.territoryArr],
        month: this.month || moment().format("YYYY-MM"),
        store_id: this.store_id,
      };
      this.loading = true;
      http
        .post("b2b_sever/gkGetFeedback/SalesClientDetail", forms)
        .then((res) => {
          this.loading = false;
          this.amount_quantity = 0;
          this.tableData = res.data;
          this.tableData.forEach((item) => {
            this.amount_quantity += parseFloat(item.actual_quantity);
          });
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    salesClientYearDetail(row) {
      this.$router.push({
        path: "/salesClientYearDetail?sku_id=" + row.sku_id,
      });
    },
    sortChange({ column, prop, order }) {
      if (order === "ascending") {
        this.tableData = this.tableData.sort((a, b) => {
          let v1 = new RegExp("[0-9]").test(a[prop])
            ? parseFloat(a[prop])
            : a[prop];
          let v2 = new RegExp("[0-9]").test(b[prop])
            ? parseFloat(b[prop])
            : b[prop];
          return v2 - v1;
        });
      } else {
        this.tableData = this.tableData.sort((a, b) => {
          let v1 = new RegExp("[0-9]").test(a[prop])
            ? parseFloat(a[prop])
            : a[prop];
          let v2 = new RegExp("[0-9]").test(b[prop])
            ? parseFloat(b[prop])
            : b[prop];
          return v1 - v2;
        });
      }
    },

    headerCellStyle() {
      return {
        "padding-top": "0",
        "padding-bottom": "0",
        "background-color": "#e0e0e0",
        color: "#5C575E",
      };
    },
    CellStyle({ row, column, rowIndex, columnIndex }) {
      if (column.label == "产品") {
        return {
          "padding-top": "8px",
          "padding-bottom": "8px",
          color: "#87909A",
        };
      } else if (column.label == "达成率") {
        return {
          "padding-top": "8px",
          "padding-bottom": "8px",
          color: parseFloat(row.rate) >= 100 ? "#7ED321" : "#ED3B3F",
        };
      } else {
        return {
          "padding-top": "8px",
          "padding-bottom": "8px",
          color: "#4A4A4A",
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#salesClientDetail .skuDe {
  background: #fff;
  padding: 15px 10px 10px 10px;
}
#salesClientDetail .skuDe p {
  margin: 0;
}
#salesClientDetail .summary span {
  font-weight: bold;
  color: #4d586d;
  display: inline-block;
}

#salesClientDetail .summary .summaryItem {
  font-size: 12px;
  padding-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
#salesClientDetail .summary .summaryItem2 span {
  display: inline-flex;
  align-items: center;
  padding-right: 4px;
  justify-content: space-between;
  width: 34%;
}
#salesClientDetail .summary .summaryItem2 {
  margin-top: 12px;
}

#salesClientDetail .summary .summaryItem2 span:last-child {
  width: 32%;
}
#salesClientDetail .summary .summaryItem .rate {
  color: #fff;
  padding: 3px 4px;
  border-radius: 4px;
  background: #9b9b9b;
}

#salesClientDetail {
  background: #f5f7fa;
}
.dateSelect {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
}
.dateSelect > img {
  width: 20px;
  height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/salesdata/salesClientDetail.vue